import { connect } from "react-redux"
import React, { Component } from 'react';
import './Common.css';
import './BrowseBets.css';
import { changeTextInput, navigate } from "../actions/betActions"

const stateMap = (store) => {
    return {
        textInputData: store.bet.textInputData,
        authentication: store.bet.authentication
    };
};
class BrowseBets extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.changeTextInput = this.changeTextInput.bind(this);
        this.viewProposal = this.viewProposal.bind(this);
        this.navigate = this.navigate.bind(this);
    }

    changeTextInput(event) {
        this.props.dispatch(changeTextInput(event.target.name, event.target.value, "BROWSE_BETS"));
    }

    viewProposal(event) {

    }

    navigate(event, page) {
      this.props.dispatch(navigate(page, this.props.authentication));
    }

    render() {

      let { BROWSE_BETS={} } = this.props.textInputData;
      let { username="" } = BROWSE_BETS;

      return (
        <div>

          <div className="section">
            <div className="">
                <div className="labelInputGroup">View bets by Twitter username</div>
                <div><input placeholder="Twitter username" type="text" className="textInput widthDialogInput moveTop20" name="username" value={username} onChange={this.changeTextInput} /></div>
                <div><button className="btn moveTop20" onClick={this.viewProposal}>Click to view</button></div>
            </div>
          </div>

          <div className="sectionNoPadding">
            <div className="titleCard">Recent bets</div>
            <div className="summaryGap"></div>

            <div className="errorCard hide">No bets yet</div>
            <div className="summaryGap hide"></div>

            <div className="dialogTable" onClick={(e) => this.navigate(e, "VIEW_PROPOSAL")}>
                
                    <div className="cardRow"><span className="strongText padTop20">@claire VS @ethbet</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">Active &middot; 5.0 ETH (~$2250 USD) &middot; Sep 12, 2018</span></div>
                
                
                    <div className="cardRow">Will Space X BFR have a successful orbital flight by the end of 2020 ...?</div>
                
            </div>
            <div className="summaryGap"></div>

            <div className="dialogTable" onClick={(e) => this.navigate(e, "VIEW_PROPOSAL")}>
                
                    <div className="cardRow"><span className="strongText padTop20">@claire VS @elliot</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">Active &middot; 5.0 ETH (~$2250 USD) &middot; Sep 12, 2018</span></div>
                
                
                    <div className="cardRow">Will Space X BFR have a successful orbital flight by the end of 2020 ...?</div>
                
            </div>
            <div className="summaryGap"></div>

            <div className="dialogTable" onClick={(e) => this.navigate(e, "VIEW_PROPOSAL")}>
                
                    <div className="cardRow"><span className="strongText padTop20">@alice VS @claire</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">Resolved &middot; 5.0 ETH (~$2250 USD) &middot; Won by @claire</span></div>
                
                
                    <div className="cardRow">Will Space X BFR have a successful orbital flight by the end of 2020 ...?</div>
                
            </div>
            <div className="summaryGap"></div>

            <div className="dialogTable" onClick={(e) => this.navigate(e, "VIEW_PROPOSAL")}>
                
                    <div className="cardRow"><span className="strongText padTop20">@maimedprisoner VS @ethbet</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">Active &middot; 5.0 ETH (~$2250 USD) &middot; Sep 12, 2018</span></div>
                
                
                    <div className="cardRow">Will Space X BFR have a successful orbital flight by the end of 2020 ...?</div>
                
            </div>
            <div className="summaryGap"></div>

            <div className="dialogTable" onClick={(e) => this.navigate(e, "VIEW_PROPOSAL")}>
                
                    <div className="cardRow"><span className="strongText padTop20">@maimedprisoner VS @ethbet</span> <span className="lightText padTop20">&nbsp;&nbsp;</span><span className="lightText padTop20">Resolved &middot; 5.0 ETH (~$2250 USD) &middot; Won by @maimedprisoner</span></div>
                
                
                    <div className="cardRow">Will Space X BFR have a successful orbital flight by the end of 2020 ...?</div>
                
            </div>
            <div className="summaryGap"></div>

          </div>
       </div>
      );
    }
  }
  
  export default connect(stateMap)(BrowseBets);



// WEBPACK FOOTER //
// ./src/components/BrowseBets.js